/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section3_Li1Inputs */

const en_terms_section3_li1 = /** @type {(inputs: Terms_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the service to process or distribute malicious content`)
};

const ko_terms_section3_li1 = /** @type {(inputs: Terms_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`악성 콘텐츠를 처리하거나 배포하기 위해 서비스를 사용하는 행위`)
};

const ja_terms_section3_li1 = /** @type {(inputs: Terms_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`悪意のあるコンテンツの処理や配布にサービスを使用すること`)
};

/**
* | output |
* | --- |
* | "Use the service to process or distribute malicious content" |
*
* @param {Terms_Section3_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section3_li1 = /** @type {((inputs?: Terms_Section3_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section3_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section3_li1(inputs)
	if (locale === "ko") return ko_terms_section3_li1(inputs)
	return ja_terms_section3_li1(inputs)
});